<script lang="ts" setup generic="T extends string | Slide | ImageSlide">
import type { ImageSlide, Slide } from '~/types/elementsUi'
import { carouselImages } from '~/models/images'

interface TestimonialCarouselProps {
  type?: 'image' | 'video'
  slides: T[]
  srLabel: string
}

const props = withDefaults(defineProps<TestimonialCarouselProps>(), {
  type: 'image'
})

const isImageSlide = (slide: Slide | string | ImageSlide): slide is ImageSlide => {
  return typeof slide === 'object' && 'key' in slide
}
</script>

<template>
  <VCarousel
    :items="slides"
    :number-of-items="1"
    loop
    dots
    :autoplay="{ delay: 10000 }"
    :ui="{
      viewport: 'max-w-lg mx-auto',
      item: 'flex justify-center'
    }"
    v-slot="{ item: slide, index }"
    :sr-label
  >
    <figure v-if="type === 'image' && (typeof slide === 'string' || isImageSlide(slide))">
      <VImage
        :image="{
          src: typeof slide === 'string' ? slide : carouselImages[slide.key],
          alt: {
            nl: `Slide ${index + 1}`,
            en: `Slide ${index + 1}`
          }
        }"
        class="h-128 w-lg object-cover"
        loading-type="lazy"
        draggable="false"
        sizes="512px"
      />
      <figcaption v-if="typeof slide !== 'string'" class="empty:hidden">
        <p v-if="slide.name" class="mt-4! mb-2! text-lg font-bold">
          {{ slide.name }}
        </p>
        <q v-if="slide.quote" class="block text-2xl font-normal">
          {{ slide.quote }}
        </q>
      </figcaption>

      <slot :slide="slide" :index="index" name="slide-footer" />
    </figure>
    <VVideo
      v-else-if="type === 'video' && typeof slide === 'string'"
      :videos="{ src: slide, type: 'video/mp4' }"
      class="h-128 w-lg object-cover"
    />
  </VCarousel>
</template>

<style scoped></style>
